export function shouldSucceedWithProbability(probability: number) {
  return probability >= Math.random();
}

export function isEven(value: number) {
  return value % 2 === 0;
}

export function roundToDecimals(value: number, decimals = 2): number {
  const factor = Math.pow(10, decimals);

  return Math.trunc(value * factor) / factor;
}
